import { useState, useEffect } from 'react';
import HeroTriptych from '../components/HeroTriptych';
import SEO from '../components/SEO';
import './Home.css';

const rotatingWords = [
  { word: 'destruction', className: 'thesis__word--destruction' },
  { word: 'trust', className: 'thesis__word--trust' },
  { word: 'partnership', className: 'thesis__word--partnership' },
  { word: 'restoration', className: 'thesis__word--restoration' },
];

export default function Home() {
  const [wordIndex, setWordIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    const interval = setInterval(() => {
      setAnimating(true);
      setTimeout(() => {
        setWordIndex((prev) => (prev + 1) % rotatingWords.length);
        setAnimating(false);
      }, 400);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const current = rotatingWords[wordIndex];

  return (
    <main id="main-content">
      <SEO
        description="Elijah Moreno is an Indigenous social scientist at Cornell University studying how federal Indian policy shapes governance, economic life, and institutional capacity in tribal nations."
        path="/"
      />
      <section className="hero-landing">
        <h1 className="sr-only">Elijah Moreno, Indigenous Social Scientist, Cornell University</h1>
        <section className="thesis thesis--top">
          <div className="container--narrow">
            <p className="thesis__statement">
              Beyond shaping outcomes, policy decides who has the capacity to act and whose actions matter
            </p>
          </div>
        </section>
        <HeroTriptych />
        <section className="thesis">
        <div className="container--narrow">
          <p className="thesis__statement">
            Federal Indian policy is the system that produces{' '}
            <span className={`thesis__word ${current.className} ${animating ? 'thesis__word--exit' : 'thesis__word--enter'}`}>
              {current.word}
            </span>
          </p>
        </div>
        </section>
      </section>
    </main>
  );
}
